import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CommodityBuyerIcon from "../../assets/Icon/CommodityBuyerIcon.png";
import { useNavigate } from "react-router-dom";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import CustomTabs from "../../components/Custom/CustomTabs";

export default function AvailableCommodities() {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [commodities, setCommodities] = useState([]);
  const [selectedCommodity, setSelectedCommodity] = useState("");
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [showEmptyState, setShowEmptyState] = useState(true);

  const fetchStateList = async () => {
    try {
      const response = await api.get("/common/states/");
      setStates(response.data);
    } catch (error) {
      console.error("Error fetching States list:", error);
    }
  };

  const fetchCommodityList = async () => {
    try {
      const response = await api.get("/common/commodities/");
      setCommodities(response.data);
    } catch (error) {
      console.log("Error Fetching Commodities list:", error);
    }
  };

  const handleStateChange = (stateId) => {
    setSelectedState(stateId);
    if (selectedCommodity) {
      fetchCommodities(stateId, selectedCommodity);
    }
  };

  const handleCommodityChange = (commodityId) => {
    setSelectedCommodity(commodityId);
    if (selectedState) {
      fetchCommodities(selectedState, commodityId);
    }
  };

  useEffect(() => {
    fetchStateList();
    fetchCommodityList();
    setLoading(false);
  }, []);

  const fetchCommodities = (state, commodity) => {
    api
      .get(`/buyer/commodities/?state_id=${state}&commodity_id=${commodity}`)
      .then((result) => {
        setData(result.data);
        console.log(result.data);
        setShowEmptyState(
          !result.data ||
            (result.data.total_fpos === 0 &&
              result.data.total_independent_farmers === 0)
        );
      });
  };

  const handleCardClick = (fpoId) => {
    navigate(
      `fpo?fpoId=${fpoId}&stateId=${selectedState}&commodityId=${selectedCommodity}`
    );
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "94vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {t("View Available Commodities")}
          </Typography>

          <Grid container spacing={0}>
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel id="district-select-label">{t("State")}</InputLabel>
                <Select
                  labelId="district-select-label"
                  id="district-select"
                  label={t("district")}
                  name="district"
                >
                  {states.map((state) => (
                    <MenuItem
                      key={state.id}
                      value={state.name}
                      onClick={() => handleStateChange(state.id)}
                    >
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel id="commodity-select-label">
                  {t("Commodity")}
                </InputLabel>
                <Select
                  labelId="commodity-select-label"
                  id="commodity-select"
                  label={t("Commodity")}
                  name="commodity"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250, // This controls the height of the dropdown
                        width: "100%",
                      },
                    },
                  }}
                >
                  {commodities.map((commodity) => (
                    <MenuItem
                      key={commodity.id}
                      value={commodity.name}
                      onClick={() => {
                        handleCommodityChange(commodity.id);
                      }}
                    >
                      {commodity.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={5} sx={{ margin: "16px auto" }}>
              <Divider sx={{ backgroundColor: "#A5A5A5" }} />
            </Grid>
          </Grid>

          {!showEmptyState && (
            <div
              style={{
                overflowY: "auto",
                height: "83%",
                maxHeight: "83%",
              }}
            >
              <CustomTabs
                numTabs={2}
                tabTitles={[t("FPOs"), t("Farmers")]}
                counts={[data.total_fpos, data.total_independent_farmers]}
                onTabChange={setActiveTab}
                textColors={["black", "black"]}
              />

              {activeTab === 0 ? (
                <>
                  {data.fpos.map((item) => (
                    <div style={{ width: "99%" }} key={item.id}>
                      <ListGenericCard
                        key={item.id}
                        title={`${item.fpo__full_name}`}
                        subtitle={[
                          `${item.farmer_count} Farmers`,
                          `${item.harvest_sum} Kg`,
                          `${item.last_harvest_date}`,
                        ]}
                        onClick={() => {
                          handleCardClick(item.fpo_id);
                        }}
                      />
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {data.independent_farmers.map((item) => (
                    <div style={{ width: "99%" }} key={item.id}>
                      <ListGenericCard
                        key={item.id}
                        title={`${item.full_name}`}
                        subtitle={[
                          `${item.harvest_sum} Kg`,
                          `${item.last_harvest_date}`,
                          `${item.phone_number}`,
                        ]}
                        onClick={() => {}}
                      />
                    </div>
                  ))}
                </>
              )}
            </div>
          )}

          {showEmptyState && (
            <div
              style={{
                height: "66%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={CommodityBuyerIcon}
                  alt="No Commodity Available"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />

                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, textAlign: "center" }}
                >
                  {t("Currently No Commodity Available")}
                </Typography>
              </div>
            </div>
          )}
        </Container>
      </LoaderContainer>
    </>
  );
}
